import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IEditTagSearchCriteriaDTO, ISummarySearchDTO } from "../../services/setpoint-administration-service/Models";

export const keys = {
    all: ["alarm-setpoint-admin"],

    referenceData: (groupID: number, 
        organizationID: number

    ) => [
        ...keys.all,
        "referencedata", {
            groupID,
            organizationID         
            }
    ],
    setPoints: (
        groupID: number,
        //page: number,
        //pageSize: number,
        searchCriteria: ISummarySearchDTO
        ) => [
            ...keys.all,
            "setpoints", {
                groupID,
                //page,
                //pageSize,
                searchCriteria
                }
        ],

    groupedSetPoints: (
        groupID: number,
        objectType: eLynxObjectTypeEnum,
        //page: number,
        //pageSize: number,
        searchCriteria: ISummarySearchDTO
        ) => [
            ...keys.all,
            "groupedsetpoints", {
                groupID,
                objectType,
                //page,
                //pageSize,
                searchCriteria
                }
        ],
    setPointUsage: (
        groupID: number,
        setpointID: number

        ) => [
            ...keys.all,
            "setpointusage", {
                groupID,
                setpointID,
                }
        ],
    objectsWithoutSetPoints: (
        groupID: number,
        searchCriteria: ISummarySearchDTO

        ) => [
            ...keys.all,
            "objectswithoutsetpoints", {
                groupID,
                searchCriteria,
                }
        ],
    setpointsWithoutObjects: (
        groupID: number,
        searchCriteria: ISummarySearchDTO

        ) => [
            ...keys.all,
            "setpointswithoutobjects", {
                groupID,
                searchCriteria,
                }
        ],
    getSetpoint: (
        groupID: number,
        setpointID: number | undefined,
        organizationID: number | undefined,
        ) => [
            ...keys.all,
            "getSetpoint", {
                groupID,
                setpointID,
                organizationID
                }
        ],
    getAvailableUsageObjects: (
        groupID: number,
        searchCriteria: IEditTagSearchCriteriaDTO
        ) => [
            ...keys.all,
            "availableUsageObjects", {
                groupID,
                searchCriteria
                }
        ],
    similarPoints: (
        groupID: number,
        organizationID: number,
        tagID: number
        ) => [
            ...keys.all,
            "similarSetpoints", {
                groupID,
                organizationID,
                tagID
                }
        ],
    availableSetpoints: (
        groupID: number
    ) => [
            ...keys.all,
            "availableSetpoints", {
                groupID
            }
        ]
};

